import script from "./retailers.vue?vue&type=script&setup=true&lang=js"
export * from "./retailers.vue?vue&type=script&setup=true&lang=js"

import "./retailers.vue?vue&type=style&index=0&id=0c419522&lang=scss&scoped=true"

import exportComponent from "/Users/jamiehall/Documents/GitHub/_cs-org/cs-captain-morgan-1022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c419522"]])

export default __exports__